import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import {BaseComponent} from "../../views/base.component";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {ModalService} from "../../views/modal/base_modal.component";
import {EventsService} from "../../lib/EventsService";
import {HelperService} from "../../lib/helper.service";
import {TranslateService} from "../../translate/translate.service";
import { BillingService2 } from "../billing.service";
import { mergeFilterParams } from "../../lib/lib";
import { FilterParams } from "../../models/filter_form.model";


@Component({
  selector: 'app-geo',
  templateUrl: './geo.component.html'
})
export class GeoComponent extends BaseComponent {
	addFilterParams = {
		userType: 'user'
	};

	expandCountry = {
		// 'Российская Федерация',
		// 'Украина',
		// 'Казахстан',
		// 'Беларусь'
		'ru': 1,
		'ua': 1,
		'kz': 1,
		'by': 1
	};
	
	
	regionLoaders = {};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}
	
	
	async getData() {
		await this.getList();
	}
	
	
	// Получить данные для тотала (дополнительного)
	async getList() {
		this.statsLoader = true;
		const { stats } = await this.service2.geo.stats(this.filter.filterParams).toPromise();
		this.stats = stats;
		this.statsLoader = false;
	}
	
	
	async showRegionList(stat) {
		if (stat.regionList) return true;
		
		try {
			this.regionLoaders[stat.location] = true;
			
			const { stats } = await this.service2.geo.stats(
				mergeFilterParams(
					this.filter.filterParams,
					<FilterParams>{ geoLocation: stat.location }
				)
			).toPromise();
			
			stat.regionList = stats;
		} catch(err) {
			// ничего не делаем, поскольку у каждого запроса к серверу и так есть дефотное поведение при ошибке
		}
		
		delete this.regionLoaders[stat.location];
	}
	
	
	downloadCSV() {
		window.location.href = this.service2.geo.downloadFileRoute(
			this.filter.getCopyFilterParams({
				reportGUID: this.filter.reportGUID,
			}),
			'csv'
		)
	}
}

